module.exports = __webpack_public_path__ + "static/img/纳税申报配图.3975199f.png";